const getColorStop = (chart, value) => {
    const yScale = chart.scales['y-axis-0']

    return Math.max(0, Math.min(yScale.getPixelForValue(value || 0) / chart.height, 1))
}

/**
 * Creates a single gradient with the "gradientStart"-color that starts at the maxmium value
 * of the dataset, and ending at the minimum value of the dataset with the "gradientEnd"-color.
 *
 * @param {Object} chart chart object
 * @param {number} datasetIndex index of dataset
 * @param {string} gradientStart gradient color string in rgba, e.g.: 'rgba(0, 194, 175, 0.8)'
 * @param {string} gradientEnd gradient color string in rgba, e.g.: 'rgba(0, 194, 175, 0.3)'
 * @returns
 */
export const createSingleGradient = (chart, datasetIndex, gradientStart, gradientEnd,) => {
    const dataset = chart.data.datasets[datasetIndex]
    const gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.height)

    const { min, max } = dataset

    gradient.addColorStop(getColorStop(chart, min), gradientEnd)
    gradient.addColorStop(getColorStop(chart, max), gradientStart)

    return gradient
}